import { useState, useCallback, FunctionComponent, useEffect } from 'react';

// Utilities
import classnames from 'classnames';

// Components
import Image from '@Components/Utils/Image';
import FormCooperation from '../FormCooperation';
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Styles
import styles from './Cooperate.module.scss';

interface CooperateProps {
    className?: string;
    onBack?: () => void;
}

const OPTIONS = [
    {
        tab: 'doctor',
        title: 'Tôi là Bác sĩ',
        icon: '/assets/bottomAction/doctor.png',
    },
    {
        tab: 'clinic',
        title: 'Hợp tác phòng khám, cơ sở y tế',
        icon: '/assets/bottomAction/clinic.png',
    },
    {
        tab: 'nursing',
        title: 'Tôi là điều dưỡng',
        icon: '/assets/bottomAction/nursing.png',
    },
    {
        tab: 'enterprise',
        title: 'Khám sức khỏe doanh nghiệp',
        icon: '/assets/bottomAction/enterprise.png',
    },
];

const Cooperate: FunctionComponent<CooperateProps> = ({ onBack, className }) => {
    const { deviceType } = useViewDetected();
    const [tab, setTab] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(false);

    const goToTab = (tab) => {
        setTab(tab);
        setIsActive(true);
    };

    useEffect(() => {
        let timeout;
        if (!isActive) {
            timeout = setTimeout(() => {
                if (!isActive) {
                    setTab('');
                }
            }, 350);
        }

        return timeout;
    }, [isActive]);

    const goBack = useCallback(() => {
        setIsActive(false);
    }, []);

    const backRoot = useCallback(() => {
        onBack();
        goBack();
    }, []);

    const renderOption = () => {
        return OPTIONS.map((item, index) => (
            <div key={`option-${index}`} className={styles.option} onClick={() => goToTab(item.tab)}>
                <Image src={item.icon} width={24} height={24} />
                {item.title}
            </div>
        ));
    };

    const wrapperClassName = classnames([
        styles.wrapper,
        styles[deviceType],
        {
            [styles.choose]: isActive,
        },
        className,
    ]);

    return (
        <div className={wrapperClassName}>
            <div className={styles.tabs}>
                <div className={styles.head_content}>
                    <span className={styles.back} onClick={backRoot} />
                    <div className={styles.title}>Chọn hình thức hợp tác</div>
                    <div className={styles.subtitle}>
                        Vui lòng chọn hình thức hợp tác với eDoctor.
                        <br />
                        Sau đó cung cấp thông tin, chúng tôi sẽ liên hệ lại
                        <br />
                        trong thời gian sớm nhất
                    </div>
                </div>

                <div className={styles.options}>{renderOption()}</div>
            </div>
            <FormCooperation tab={tab} onBack={goBack} onBackRoot={backRoot} className={styles.form_cooperation} />
        </div>
    );
};

Cooperate.defaultProps = {
    className: '',
    onBack: () => null,
};

export default Cooperate;
